import React, { Component } from 'react';
import TableComponent from '../TableComponent'; // Assuming TableComponent is in the same directory
import svasti_logo from "../../assets/images/svasti_logo.png";
import {SV_API_BASE_URL, SV_CB_API_BASE_URL} from '../../config/api_endpoint'
import { CB_API_KEY } from '../../config/constant';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

export default function CBHistoryDetails() {
  const searchParams = new URLSearchParams(window.location.search.toLowerCase());

  const custNumber = searchParams.get('customernumber');
  const aadhaarCard = searchParams.get('aadharcardnumber');
  const showAllInstitution = searchParams.get('showallinstitution') || 'false';

    //const custNumber = new URLSearchParams(window.location.search.toLowerCase()).get('customerNumber');
    //const aadhaarCard = new URLSearchParams(window.location.search.toLowerCase()).get('aadharCardNumber');

    return <CBHistory custNumber={parseInt(custNumber)} aadharCardNumber= {aadhaarCard} showAllInstitution = {showAllInstitution} />
}

export class CBHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      error: null,
      showAllInstitution: 'false',
      CustomerInformation: [],
    };
  }

  componentDidMount() {
      const custNumber = this.props.custNumber;
      const customeridcardnumber = this.props.aadharCardNumber;
      let showAllInstitution = this.props.showAllInstitution;

      if(!showAllInstitution)
      {
        showAllInstitution='false';
        this.setState({ showAllInstitution });
      }
      else if(showAllInstitution.toLowerCase() !== 'true' && showAllInstitution.toLowerCase() !== 'false')
      {
        let error = {message: 'Invalid Parameter Value. showAllInstitution can True or False'};
        this.setState({ error, loading: false });
        return "";
      }

      this.setState({ showAllInstitution });

      if(custNumber)
      {
        this.fetchCustomerInformation().then(data => {
          if(data.length > 0)
          {
            this.fetchEnquiryRequest(data[0].customeridcardnumber).then(nodata => {
              if(nodata !== "No CB Enquiry")
              {
                this.fetchCBHistory(data[0].customeridcardnumber);
              }
              
            })
            
          }
        });
      }
      else if(customeridcardnumber)
      {
        this.fetchEnquiryRequest(customeridcardnumber).then(nodata => {
          if(nodata !== "No CB Enquiry")
          {
            this.fetchCBHistory(customeridcardnumber);
          }
        })
      }
      else
      {
        let error = {message: 'Invalid Parameters. Please provide customerNumber or  aadharCardNumber'};
        this.setState({ error, loading: false });
        return "";
      }
        
    }

    fetchCBHistory = async(aadharCardNumber) => {
        fetch(SV_CB_API_BASE_URL + "cb/cbHistory?aadharCardNumber="+ aadharCardNumber , {
            headers: {
            'X-API-KEY': CB_API_KEY
            }
        })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        if(response.statusText=="Not Found")
        {
          throw new Error('No CB History');
        }
        throw new Error('Network response was not ok.');
      })
      .then(data => {
        fetch(SV_API_BASE_URL + "cbHistory?AadhaarCardNumber=" + aadharCardNumber)
        .then(historyResponse => historyResponse.json())
        .then(historyData => {
          fetch(SV_API_BASE_URL + "GetCustomerInformationByAadhaar?AadhaarCardNumber=" + aadharCardNumber)
          .then(custInfoResponse => custInfoResponse.json())
          .then(custInfodata => {
            console.log('History data:', historyData);
            console.log('data.data :', data.data);
            const resultValue = historyData.Result;
            const custResult = custInfodata[0];
            const updatedData = data.data.map(row => ({
              ...row,
              Result: resultValue,
              custInfoData: custResult
            }));
            // Continue with the rest of your logic
            this.setState({ data: updatedData, loading: false });
          })
        })
        .catch(historyError => {
          console.error('Error fetching history:', historyError);
          // Handle errors from the history fetch request
          throw new Error('Error fetching history');
        });
      })
      .catch(error => {
        this.setState({ error, loading: false });
      });
    }

    fetchCustomerInformation = async () => {
        try 
        {
            const custNumber = this.props.custNumber;
            const custResponse = await fetch(SV_API_BASE_URL +'GetCustomerInformation?CustomerNumber=' + custNumber);
            const custData = await custResponse.json();

            if(custData.length>0)
            {
                this.setState({ CustomerInformation: custData });
                return custData;
            }
            else{
              throw new Error('Invalid customer id');
            }

            return "";
        } catch (error) {
            this.setState({ error, loading: false });
            return "";
            //errorlog.error(error);
            //console.error(error);
        }
    }

    fetchEnquiryRequest = async (aadharCardNumber) => {
      try 
      {
          const cbEnquiryResponse = await fetch(SV_API_BASE_URL +'CBEnquriyRequest?aadhaarCard=' + aadharCardNumber);

          if(cbEnquiryResponse.status !== 200)
          {
            throw new Error('No CB Enquiry');
          }

          const cbEnquriyResult = await cbEnquiryResponse.json();

          if(cbEnquriyResult.length>0)
          {
	    if(cbEnquriyResult[0].requestStatus===null)
            {
              throw new Error('Request Status is empty. Please execute CB Enquiry again to view CB History.');
            }
            else
            {
              return "";
            }
          }
          else{
            throw new Error('No CB Enquiry');
            return "";
          }

      } catch (error) {
          this.setState({ error, loading: false });
          return "No CB Enquiry";
          //errorlog.error(error);
          //console.error(error);
      }
  }

  render() {
    const { data, loading, error, showAllInstitution } = this.state;

    if (loading) {
      return (
        <div>
            <Alert key='primary' variant='primary'>
            <center>
                <h4>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        />
                    &nbsp; Loading...
                </h4>
            </center>

        </Alert>
        </div>
      );
    }

    if (error) {
      return <div>
      <Alert key="danger" variant="danger">
        <center>{error.message}</center>
      </Alert></div>;
    }

    return <TableComponent data={data} showAllInstitution={showAllInstitution} />;
  }
}


